import { memo } from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="page_center">
      <div className="loader_cell">
        <div className="card loader_card">
          <span className="flower-loader">Loading&#8230;</span>
        </div>
      </div>
    </div>
  );
};
export default memo(Loader);